import { useEffect, useState } from 'react';

export const useDocumentExpiry = (expiresAt: number | undefined) => {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    if (!expiresAt) return;
    const update = () => setNow(Date.now());
    update();
    const timer = window.setInterval(update, 1000);
    window.addEventListener('focus', update);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', update);
    };
  }, [expiresAt]);
  return {
    expired: expiresAt !== undefined && now >= expiresAt,
    expiring: expiresAt !== undefined && now < expiresAt && expiresAt - now <= 5 * 60 * 1000,
  };
};
